import { __assign, __rest } from "tslib";
import React from 'react';
import { Platform, View } from 'react-native';
import moment from 'moment';
import { PnmacCard, PnmacCardActions, PnmacCardContent, PnmacCardTitle, PnmacHtmlToNative, PnmacImage, PnmacNavigation, PnmacText, PnmacUIButton } from 'pnmac-universal-components';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events';
import PaymentTileLanding from '../../components/PaymentTileLanding';
import CaretRightWhiteSVG from '../../assets/caret-right-white.svg';
import PaymentReceivedSVG from '../../assets/payment-received.svg';
export var PaymentSection = function (_a) {
  var _b;
  var matches = _a.matches,
    enabled = _a.enabled,
    props = __rest(_a, ["matches", "enabled"]);
  var layout = props.layout,
    translations = props.translations,
    trackerDispatcher = props.trackerDispatcher;
  var lastPaymentReceivedDate = layout.lastPaymentReceivedDate;
  var iconSize = matches.small ? 40 : 65;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      display: 'flex',
      flexDirection: matches.large ? 'row' : 'column'
    }
  }, /*#__PURE__*/React.createElement(PaymentTileLanding, __assign({
    matches: matches
  }, props)), /*#__PURE__*/React.createElement(View, {
    nativeID: "PaymentTile",
    style: {
      flexGrow: 1,
      flexBasis: matches.large ? '30%' : '100%',
      padding: 10,
      flexShrink: 1
    }
  }, /*#__PURE__*/React.createElement(PnmacCard, {
    nativeID: "cdPaymentTile",
    elvation: 0,
    style: Platform.select({
      web: {
        paddingVertical: 9,
        paddingHorizontal: 16,
        height: 280,
        backgroundColor: '#B5DBBE'
      },
      default: {
        paddingVertical: 9,
        paddingHorizontal: 16,
        minHeight: 280,
        backgroundColor: '#B5DBBE'
      }
    })
  }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
    titleStyle: {
      fontWeight: 'bold',
      fontSize: !matches.small ? 24 : 20
    },
    title: translations === null || translations === void 0 ? void 0 : translations.PaymentReceived,
    subtitle: translations === null || translations === void 0 ? void 0 : translations.Received,
    right: function () {
      return PnmacImage(layout.mobile ? 'paymentReceived' : PaymentReceivedSVG, iconSize, 'PaymentReceived icon', 'css');
    }
  }), /*#__PURE__*/React.createElement(PnmacCardContent, {
    style: {
      marginTop: 20,
      height: 100
    }
  }, /*#__PURE__*/React.createElement(View, null, !lastPaymentReceivedDate ? (/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
    color: "#003087",
    value: translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg3
  }, props)))) : (/*#__PURE__*/React.createElement(PnmacText, null, (_b = translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg1) !== null && _b !== void 0 ? _b : '')), /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontWeight: '700'
    }
  }, !lastPaymentReceivedDate ? '' : ' ' + moment(lastPaymentReceivedDate).format('MM/DD/YYYY') + '.')), /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({
    color: "#003087",
    value: !lastPaymentReceivedDate ? '' : translations === null || translations === void 0 ? void 0 : translations.PaymentReceivedmsg2
  }, props)))), /*#__PURE__*/React.createElement(PnmacCardActions, {
    style: Platform.select({
      web: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'flex-end'
      },
      default: {
        flex: 1,
        justifyContent: 'center',
        marginBottom: 5,
        alignItems: 'flex-end'
      }
    })
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    hoverColor: '#167027',
    uppercase: true,
    mode: "contained",
    disabled: !enabled,
    iconSize: 30,
    iconStyles: {
      marginLeft: 10
    },
    style: Platform.select({
      web: {
        backgroundColor: '#1D8731',
        shadowColor: 'white'
      },
      default: {
        backgroundColor: '#1D8731',
        shadowColor: 'white',
        width: '100%'
      }
    }),
    onPress: function () {
      trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Loan Activity Button Clicked', 2);
      PnmacNavigation(__assign({
        action: {
          pathname: "/Loan/Activity"
        }
      }, props));
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag: "btnLnActivity",
    style: {
      fontFamily: 'Montserrat',
      fontWeight: '700',
      textTransform: 'uppercase',
      color: 'white'
    }
  }, translations === null || translations === void 0 ? void 0 : translations.ViewLoanActivity), PnmacImage(layout.mobile ? 'caretRightWhite' : CaretRightWhiteSVG, 25, 'Loan Activity CaretRight icon', 'xml'))))));
};